import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e3c23ba4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c23ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3c23ba4')) {
      api.createRecord('e3c23ba4', component.options)
    } else {
      api.reload('e3c23ba4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e3c23ba4&scoped=true&", function () {
      api.rerender('e3c23ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/resaleTaxConfig/index.vue"
export default component.exports